import {
    SAVE_APPLICATION_LOADING,
    SAVE_APPLICATION_COMPLETE,
    SAVE_APPLICATION_FAILED,
    SAVE_APPLICATION_RESET
} from './SaveApplication.actions';

const initialState = {
    loading: false,
    success: false,
    failure: false
};

interface SaveApplicationAction {
    type: string;
}

export default function (state = initialState, action: SaveApplicationAction) {
    switch (action.type) {
        case SAVE_APPLICATION_LOADING:
            return {
                ...state,
                loading: true,
                success: false,
                failure: false
            };
        case SAVE_APPLICATION_COMPLETE:
            return {
                ...state,
                loading: false,
                success: true,
                failure: false
            };
        case SAVE_APPLICATION_FAILED:
            return {
                ...state,
                loading: false,
                success: false,
                failure: true
            };
        case SAVE_APPLICATION_RESET:
            return {
                ...state,
                loading: false,
                success: false,
                failure: false
            };
        default:
            return state;
    }
}
